<template>
    <div class="app has-header holiday-overview">
        <div class="header main">
            <div class="align-left">
            <dateselectionheader
                :label="yearDisplay"
                @PrevDate="PreviousDate"
                @NextDate="NextDate"
                @CalendarOpen="toggleDatePicker"
                @SetToday="SetDateToCurrentDay"/>
            </div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons"/>
            </div>
            <div class="align-right">
                <headerbuttonstack :state="sideButtons"/>
            </div>
        </div>
        
        <!--<datatabletextfilter @update="SetFilterText"></datatabletextfilter> -->
        <div class="tablecontainer scrollbar-container">
            <div style="margin-bottom: 70px;" v-if="!loading">
                <datatable :state="dataTableState" :filter-state="tableFilters"/>
            </div>
        </div>
        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
        <employeeworkbalancecreation ref="employeeworkbalancecreation" ></employeeworkbalancecreation>
    </div>
</template>

<script>
    import datatable from '../uicomponents/datatable.vue';
    import datatabletextfilter from '../uicomponents/datatabletextfilter.vue';
    import employeeworkbalancecreation from '../workbalancecontext/EmployeeWorkBalanceCreation.vue';
    import { mapState, mapGetters } from 'vuex';
    export default {
        name: 'vacationoverview',
        components: {
            datatable,
            datatabletextfilter,
            employeeworkbalancecreation
        },
        data () {
            return {
                loading: true,
                filterDropdownOptions: [],
                filterText: '',
                loadingText: '',
                date: null,
                tableFilters: {},
                employeeMap: {},
                vacationMap: {},
                employeeZeroMonthsMap: {},
                usageStartDateMoment: null,
                preUsageStartDateBalances: [],
                employeeWorkBalanceMapForYear: {},
                vacationEntryMap: {},
                displayInHours: false,
                displaySummed: false,
                displayExact: true,
                displayUsagePercentage: false,
                sortByName: true,
                
            }
        },
        created: function () {
            this.date = this.$helpers.getMomentTZStartOfDay().startOf('year');

        },
        mounted(){
            let view = this;
            if(this.storeSettings.companyId == 153){
                this.displayInHours = true;
            }
            if((this.storeSettings.country == 2 || this.storeSettings.country == 8) && this.storeSettings.marketType == 1){
                // mcd in germany --> display rounded days and not exact values
                this.displayExact = false;
            }
        },
        computed: {
            ...mapGetters([
                'storeId',
                'storeSettings',
                'employeeContractMap',
                'holidayMap',
                'employeeWorkbalanceMap',
                'spotMap'
            ]),
            displayMenuState(){
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [
                        {
                            label: this.$t('global.ui.viewOptions'),
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: this.sortByName ? "fa-sort-numeric-down" : "fa-sort-alpha-down",
                                    text: !this.sortByName ? this.$t('global.ui.sortByName') : this.$t('global.ui.sortByPersonalNumber') ,
                                    disabled: false,
                                    click: () => { view.sortByName = !view.sortByName;}
                                },
                                {
                                    closeOnClick: true,
                                    icon: view.displayInHours ? 'fa-toggle-on' : 'fa-toggle-off',
                                    text: !view.displayInHours ? this.$t('pref.main.showContractHours') : this.$t('pref.main.showDays'),
                                    click: () => {
                                        view.displayInHours = !view.displayInHours;
                                        if(view.displayInHours){
                                            view.displayExact = true;
                                        }
                                        view.BuildVacationEntryMap();
                                    }
                                },
                                {
                                    closeOnClick: true,
                                    icon: view.displayExact ? 'fa-toggle-on' : 'fa-toggle-off',
                                    text: !view.displayExact ? this.$t('pref.main.showDecimals') : this.$t('pref.main.showFullDays'),
                                    click: () => {
                                        view.displayExact = !view.displayExact;
                                        if(!view.displayExact){
                                            view.displayInHours = false;
                                        }
                                        view.BuildVacationEntryMap();
                                    }
                                },
                                {
                                    closeOnClick: true,
                                    icon: view.displaySummed ? 'fa-toggle-on' : 'fa-toggle-off',
                                    text: !view.displaySummed ? this.$t('pref.main.showSums') : this.$t('pref.main.showAliquot'),
                                    click: () => {
                                        view.displaySummed = !view.displaySummed;
                                        view.BuildVacationEntryMap();
                                    }
                                },
                                {
                                    closeOnClick: true,
                                    icon: view.displayUsagePercentage ? 'fa-toggle-on' : 'fa-toggle-off',
                                    text: !view.displayUsagePercentage ? this.$t('pref.main.showUsagePercent') : this.$t('pref.main.showUsageSum'),
                                    click: () => {
                                        view.displayUsagePercentage = !view.displayUsagePercentage;
                                        view.BuildVacationEntryMap();
                                    }
                                },
                                 
                            ]
                        },
                        
                            
                    ],
                    items: []
                };
                

                return state;
            },
            reportMenuState() {
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [
                        {
                            label: this.$t('pref.main.export'),
                            items: [
                                {
                                    closeOnClick: true,
                                    icon: 'fa-file-csv',
                                    text: this.$t('global.ui.exportCsv'),
                                    click: () => {
                                        view.openExportCsvPopup();
                                    }
                                }
                            ]
                        },

                    ],
                    items: []
                };

                let reportGroup = {
                    label: this.$t('indicator.crew.pdfReport'),
                    items: [
                        {
                            closeOnClick: true,
                            classes: "export-save",
                            type: "block green",
                            disabled: false,
                            icon: "fa-file-pdf",
                            click: () => { view.openSelectMonthPDFPopup(); },
                            show:  true,
                            text: this.$t('pref.main.monthlyOverviewPDF'),
                            helperText: ''
                        },
                       

                    ]
                }

                state.groups.push(reportGroup);

                
                return state;
            },
            burgerMenuState(){
                let view = this;
                let state = {
                    componentref: 'burgermenustate',
                    groups: [
                        {
                            label: this.$t('pref.main.vacationPlanning'),
                            items: [
                               
                            ]
                        },
                        
                            
                    ],
                    items: []
                };
                

                
                return state;
            },
            headerButtons() {
                let view = this;

                let state= {
                    buttons: []
                };
               
                
                
                state.helperLinks = [
                {
                    icon: "fa-video",
                    title: this.$t('store.structure.watchTrainingVideo'),
                    helperText: this.$t('store.structure.watchTrainingVideoHelp'),
                    externalUrl: "https://www.youtube.com/watch_popup?v=dBXnotWZvwo",
                    externalLabel: this.$t('pref.main.trainingVideoAbsence'),
                    cancelLabel: this.$t('global.ui.close'),
                },
                    {
                        title:  this.$t('store.structure.getSupport'),
                        helperText:  this.$t('store.structure.getSupportHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/14",
                        externalLabel:  this.$t('store.structure.getSupportLabel'),
                        cancelLabel: this.$t('global.ui.close'),
                    }
                ];

                return state;
            },
            sideButtons() {
                let view = this;
                
                let state= {
                    buttons: []
                };
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-filter",
                    click: ($event) => {
                       view.OpenFilterDropdown($event);
                    },
                    tooltip: this.$t('global.ui.viewFilter')
                });
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-eye",
                    tooltip: this.$t('global.ui.viewOptions'),
                    click: ($event) => {view.OpenMenuDetails($event, this.displayMenuState)}
                });
                state.buttons.push({
                    type: "block border-r",
                    icon: "fa-print",
                    tooltip: this.$t('global.ui.reportsExports'),
                    click: ($event) => {view.OpenMenuDetails($event, this.reportMenuState)}
                });
                /*
                state.buttons.push({
                    type: "block",
                    icon: "fa-bars",
                    tooltip: "Zusatzoptionen",
                    click: ($event) => {view.OpenMenuDetails($event, this.burgerMenuState)}
                }); */
                
                return state;
            },
            rosterFromTo() {
                if(this.$store.state.loggedIn){
                    return this.$store.state.rosterFromTo;
                } else {
                    return null;
                }
            },
            yearDisplay: function() {
                if(this.date != null){
                    return this.date.format("YYYY");
                } else {
                    return '-';
                }
            },
            usageStartDate(){
                if(this.usageStartDateMoment == null){
                    this.$set(this, 'usageStartDateMoment', this.$helpers.getMomentFromStringTZ(this.storeSettings.usageStartDate));
                } 
                return this.usageStartDateMoment;
            },
            usageStartDateInCurrentYear(){
                let usd = this.usageStartDate;
                return (usd.year() == this.date.year());
            },
            usageStartDateMonth(){
                let usd = this.usageStartDate;
                return usd.month();
            },
            employeeIdPreUsageDateBalanceMap(){
                let view = this;
                let map = {};
                this.preUsageStartDateBalances.forEach(w => {
                    map[w.employeeId] = w;
                });
                return map;
            },
            
            employeeIdCarriedOverMap(){
                let view = this;
                let map = {};
                Object.values(this.employeeWorkbalanceMap).forEach(w => {
                    map[w.employeeId] = w.vacationTimeBalance;
                });
                return map;
            },
            employeeIdContractMap(){
                let view = this;
                let map = {};
                

                Object.values(this.employeeContractMap).forEach(p => {
                    if(!map[p.employeeId]){
                        map[p.employeeId] = p;
                    } else if(map[p.employeeId] && view.$helpers.getMomentFromStringTZ(p.from).isAfter(map[p.employeeId]['from'])) map[p.employeeId] = p;
                });
                return map;
            },
            employeeIdContractMultiMap(){
                let view = this;
                let map = {};
                Object.values(this.employeeMap).forEach(e => {
                    map[e.id] = [];
                });

                Object.values(this.employeeContractMap).forEach(p => {
                    if(map[p.employeeId]) map[p.employeeId].push(p);
                });
                return map;
            },
            vacationMapMomentMap(){
                let view = this;
                let map = {};
                Object.values(this.vacationMap).forEach(p => {
                    map[p.id] = {
                        fromDate: view.$helpers.getMomentFromStringTZ(p.from),
                        toDate: view.$helpers.getMomentFromStringTZ(p.to),
                        employeeId: p.employeeId,
                    };
                    map[p.id].lengthUnix = map[p.id].toDate._d.getTime() - map[p.id].fromDate._d.getTime();
                });
                return map;
            },
            holidayInDayOfYearMap(){
                let view = this;
                let map = [];
                
                for(let x = 1; x <= this.$helpers.getMomentFromValuesTZ(view.date.year(), 0, 1).endOf('year').dayOfYear(); x++)
                {
                    map[x] = false;
                }
                Object.values(this.holidayMap).forEach(h => {
                    let tempDate = view.holidayMomentMap[h.id].fromDate.clone();
                   
                    let toDate = view.holidayMomentMap[h.id].toDate;
                    while(tempDate < toDate) {
                        if(tempDate.year() == view.date.year()){
                            map[tempDate.dayOfYear()] = true;
                        }
                        tempDate.hours(0).minutes(0).seconds(0).millisecond(0).add(1,'days');
                    }
                });
                return map;
            },
            holidayMomentMap(){
                let view = this;
                let map = {};
                Object.values(this.holidayMap).forEach(h => {
                    
                    map[h.id] = {
                        fromDate: view.$helpers.getMomentFromStringTZ(h.from),
                        toDate: view.$helpers.getMomentFromStringTZ(h.to),
                    };
                    map[h.id].lengthUnix = map[h.id].toDate._d.getTime() - map[h.id].fromDate._d.getTime();
                });
                return map;
            },
            employeeVacationArrayMap(){
                let view = this;
                let map = {};
                Object.values(this.employeeMap).forEach(e => {
                    map[e.id] = [];
                });

                Object.values(this.vacationMap).forEach(p => {
                    map[p.employeeId].push(p);
                });
                return map;
            },
            
            employeeMonthlyVacationDaysMap(){
                let view = this;
                let map = {};
                Object.values(this.employeeMap).forEach(e => {
                    map[e.id] = Array(12).fill(0);
                });

                Object.values(this.vacationMap).forEach(p => {
                    let fromDate = view.vacationMapMomentMap[p.id].fromDate;
                    let toDate = view.vacationMapMomentMap[p.id].toDate;
                    let tempDate = fromDate.clone();
                    let alwaysWork = p.alwaysWork
                    
                    while(tempDate < toDate){
                        if(map[p.employeeId] == undefined){
                            map[p.employeeId] = Array(12).fill(0);
                        }
                        if(tempDate.year() == view.date.year()){
                            let vacHours = view.GetVacationHoursCountedForTimeFrame(view.employeeMap[p.employeeId],tempDate, toDate, alwaysWork);
                            
                            map[p.employeeId][tempDate.month()] += vacHours / 24;
                            
                        }
                        
                        tempDate.hours(0).minutes(0).seconds(0).millisecond(0).add(1,'days');
                    }
                   
                    
                });
                
                return map;
            },
            filteredEmployeeMap(){
                let map = {};
                let view = this;
                let employees = this.employeeMap ? Object.values(this.employeeMap) : [];
                
                employees.forEach((e) => {
                    
                    view.filterDropdownOptions.forEach(o => {
                        if(!o.all && o.show && o.spot.id == e.spotId){
                            map[e.id] = e;
                        } else if (!o.all && o.show && o.spot.id == null && e.spotId == null){
                            map[e.id] = e;
                        } 
                    });
                    
                });
                return map;
            },
            dataTableState(){
                
                let state = {};
                let view = this;
                if(!view.loading){
                    let dataArray = this.filteredEmployeeMap ? Object.values(this.filteredEmployeeMap) : [];
                    dataArray.sort(function(ea, eb) {
                        if(view.sortByName){
                            if(ea != undefined && eb != undefined){
                                if(ea.lastName < eb.lastName) return - 1;
                                if(ea.lastName > eb.lastName) return 1;
                                if(ea.lastName == eb.lastName && ea.firstName < eb.firstName) return - 1;
                                if(ea.lastName == eb.lastName && ea.firstName > eb.firstName) return 1;
                            }
                        }else{
                            if(ea != undefined && eb != undefined){
                                let eaNum = ea.personnelId;
                                let ebNum = eb.personnelId;
                                if(eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null){
                                    eaNum = parseInt(eaNum);
                                    ebNum = parseInt(ebNum);
                                    if(eaNum < ebNum) return - 1;
                                    if(eaNum > ebNum) return 1;
                                }else if(eaNum == null || eaNum == undefined){
                                    return 1;
                                }else{
                                    return -1;
                                }
                            }
                        }
                        return 0;
                    });
                    
                    let keyLabelTemplate = {name: this.$tc('global.general.employee'), carriedOver: this.$t('workBalance.payroll.carryOverShort')};
                    if(!view.sortByName) keyLabelTemplate = {personnelId: 'PN', name: this.$tc('global.general.employee'), carriedOver: this.$t('workBalance.payroll.carryOverShort')};
                    for(let x = 0; x < 12; x++){
                        keyLabelTemplate['month' + x] = this.$helpers.translateMonth(this.$helpers.getMomentTZStartOfDay().month(x).format('MMMM'));
                    }
                    keyLabelTemplate.hours = this.$t('workBalance.payroll.carryOverShort');
                    keyLabelTemplate.total = '€';


                    let dataSum = [];
                    let dataSumItem = {};
                    let dataSumItemPositive = {};
                    let dataSumItemNegative = {};
                    let monthSums = {};
                    for(let x = 0; x < 12; x++){
                        monthSums['month' + x] = {'emerging': 0, 'used': 0};
                    }
                    monthSums['carriedOver'] = 0;
                    monthSums['carriedOverPositive'] = 0;
                    monthSums['carriedOverNegative'] = 0;

                    monthSums['postCarriedOver'] = 0;
                    monthSums['postCarriedOverPositive'] = 0;
                    monthSums['postCarriedOverNegative'] = 0;
                    let sumVacationPayment = 0;
                    let sumVacationPaymentPositive = 0;
                    let sumVacationPaymentNegative = 0;

                    let sumStyle = {'font-size': '12px', 'color': 'var(--md)', 'border-right': 'solid 1px var(--contrast-1)', 'padding': '4px 0px', 'text-align': 'center'};
                    let sumStyleTotal = {'font-size': '12px', 'color': 'var(--md)', 'padding': '4px 0px', 'text-align': 'center'};
                    
                    dataArray.forEach((e) => {
                        
                        let vPayment = view.calculateVacationPaymentForEmployee(e);
                        sumVacationPayment += vPayment;
                        if(vPayment < 0){
                            sumVacationPaymentNegative += vPayment;
                        } else {
                            sumVacationPaymentPositive += vPayment;
                        }

                        for(let x = 0; x < 12; x++){
                            let mkey = 'month' + x;
                            let state = view.GetVacationEntryStateForMonth(e, x);
                            if(state.visible){
                                if(this.displaySummed){
                                    monthSums[mkey].emerging += state.sumVacationBalance * (state.displayInHours ? state.workDayHours : 1);
                                    monthSums[mkey].used += state.sumVacationUsed * (state.displayInHours ? state.workDayHours : 1);
                                } else {
                                    monthSums[mkey].emerging += state.entitled * (state.displayInHours ? state.workDayHours : 1);
                                    monthSums[mkey].used += state.currentMonth * (state.displayInHours ? state.workDayHours : 1);
                                }
                               
                            }
                            
                        }
                        let current = parseFloat(view.postCarriedOverDays(e).toFixed(2));
                        
                    
                        let carriedOverEntry = view.GetVacationEntryStateForMonth(e, 11);
                        let carriedOver = 0;
                        if(view.employeeIdCarriedOverMap[e.id] != undefined){
                            carriedOver += view.employeeIdCarriedOverMap[e.id] / 60 / 24;
                        }
                        
                        if(carriedOverEntry.displayInHours){
                            carriedOver = carriedOver * carriedOverEntry.workDayHours;
                            current = current * carriedOverEntry.workDayHours;
                        } 
                        monthSums['carriedOver'] += carriedOver;
                        monthSums['postCarriedOver'] += current;
                        if(carriedOver > 0){
                           monthSums['carriedOverPositive'] += carriedOver; 
                        } else {
                            monthSums['carriedOverNegative'] += carriedOver;
                        }
                        if(current > 0){
                           monthSums['postCarriedOverPositive'] += current; 
                        } else {
                            monthSums['postCarriedOverNegative'] += current;
                        }
                    });
                    
                    for(let x = 0; x < 12; x++){
                        let mkey = 'month' + x;
                        if(view.displayUsagePercentage){
                            let used = monthSums[mkey].used
                            let emerging = monthSums[mkey].emerging;

                            let percentage = emerging > 0 ? (used / emerging) * 100 : 0;
                            dataSumItem[mkey] = {key: mkey, label: view.$helpers.ProcessNumericLabel(percentage, 2, '.', false) + '%'};
                        } else {
                            dataSumItem[mkey] = {key: mkey, label: 
                            view.$helpers.ProcessNumericLabel(monthSums[mkey].used, 2, '.', false) + '/' + 
                            view.$helpers.ProcessNumericLabel(monthSums[mkey].emerging, 2, '.', false, !view.displayInHours && !view.displayExact)};
                        }
                       
                        dataSumItemPositive[mkey] = {key: mkey, label: "-"};
                        dataSumItemNegative[mkey] = {key: mkey, label: "-"};
                    }
                    
                   
                    let hourSumTotal = view.$helpers.ProcessNumericLabel(monthSums['postCarriedOver'], 2, '.', false, !view.displayInHours && !view.displayExact);
                    let hourSumTotalPositive = view.$helpers.ProcessNumericLabel(monthSums['postCarriedOverPositive'], 2, '.', false, !view.displayInHours && !view.displayExact);
                    let hourSumTotalNegative = view.$helpers.ProcessNumericLabel(monthSums['postCarriedOverNegative'], 2, '.', false, !view.displayInHours && !view.displayExact);

                    
                    
                    dataSumItem['hours'] = {key: 'hours', label: hourSumTotal}; 
                    dataSumItemPositive['hours'] = {key: 'hours', label: hourSumTotalPositive};
                    dataSumItemNegative['hours'] = {key: 'hours', label: hourSumTotalNegative};
                    
                    dataSumItem['carriedOver'] = {key: 'carriedOver', label: view.usageStartDateInCurrentYear && view.usageStartDateMonth > 0? '' : view.$helpers.ProcessNumericLabel(monthSums['carriedOver'], 2, '.', false, !view.displayInHours && !view.displayExact)}; 
                    dataSumItemPositive['carriedOver'] = {key: 'carriedOver', label: view.usageStartDateInCurrentYear && view.usageStartDateMonth > 0? '' : view.$helpers.ProcessNumericLabel(monthSums['carriedOverPositive'], 2, '.', false, !view.displayInHours && !view.displayExact)}; 
                    dataSumItemNegative['carriedOver'] = {key: 'carriedOver', label: view.usageStartDateInCurrentYear && view.usageStartDateMonth > 0? '' : view.$helpers.ProcessNumericLabel(monthSums['carriedOverNegative'], 2, '.', false, !view.displayInHours && !view.displayExact)}; 



                    state = this.$helpers.GetDataTableStateFromKeyLabelObject(keyLabelTemplate, dataArray);
                    state.monthSums = monthSums;

                    if(!view.sortByName){
                        state.headerMap.personnelId.width = '80px';
                    }

                    state.headerMap.name.sort = view.sortByName;
                    state.headerMap.name.width = '150px';
                    state.headerMap.name.componentTypeRow = 'employeeentry';
                    state.headerMap.name.componentStateBuilder = (data, entry) => {
                        
                        let eo =  {firstName: data.firstName, lastName: data.lastName, summary: false, splitName: true, employee: data}
                        if(view.spotMap[data.spotId] != undefined) eo.color = view.spotMap[data.spotId].color;
                        return eo;
                    }; 

                    for(let x = 0; x < 12; x++){
                        state.headerMap['month' + x].componentTypeRow = 'monthlyholidayentry';
                        state.headerMap['month' + x].componentStateBuilder = (data) => {
                            let state = view.GetVacationEntryStateForMonth(data, x);
                            return state;
                        };
                        state.headerMap['month' + x].clickOptions = {action: ($event, entry) => {
                            view.OpenMonthlyPopup(entry.data, x);
                        }};
                        state.headerMap['month' + x].stylesEntrySum = sumStyle;
                    }
                    state.headerMap['hours'].stylesEntrySum = sumStyle;
                    state.headerMap['carriedOver'].stylesEntrySum = sumStyle;
                    

                    state.headerMap.carriedOver.width = '65px';

                    state.headerMap.hours.width = '65px';
                    state.headerMap.hours.align = 'right';
                    state.headerMap.total.align = 'right';
                    state.headerMap.total.width = '100px';

                    state.headerMap.carriedOver.DisplayLabel = (data) => {
                        if(view.usageStartDateInCurrentYear && view.usageStartDateMonth > 0) return '';
                        let wbalance = view.employeeIdCarriedOverMap[data.id];
                        let balance = 0;
                        if(wbalance != undefined){
                            balance = wbalance/ 60 / 24;
                            if(!view.displayExact){
                                balance = Math.ceil(balance);
                            
                            }
                        }
                        return (Math.round(balance * 100) / 100).toFixed(2);
                    };
                    state.headerMap.hours.DisplayLabel = (data) => {
                        let current = view.postCarriedOverDays(data);
                        let carriedOverEntry = view.GetVacationEntryStateForMonth(data, 11);
                        if(carriedOverEntry.displayInHours){
                            current = current * carriedOverEntry.workDayHours;
                        } else if(!carriedOverEntry.displayExact){
                            current = Math.ceil(current);
                        }
                        return view.$helpers.ProcessNumericLabel(current, 2, '.', false);
                    }; 
                    state.headerMap.total.DisplayLabel = (data) => {
                        let vacationPayment = view.calculateVacationPaymentForEmployee(data);
                        return view.$helpers.ProcessNumericLabel(vacationPayment, 2, ',', false);
                    };

                    Object.values(state.headerMap).forEach(h => {
                        h.labelNoBreak = true;
                        h.labelSmall = true;
                        h.divider = true;
                    });

                    let keyStart = Object.keys(state.headerMap)[0];
                    dataSumItem[keyStart] = {key: keyStart, label: this.$t('pref.main.sumTotal')};
                    dataSumItem['total'] = {key: 'total', label:  '€ ' + view.$helpers.ProcessNumericLabel(sumVacationPayment, 2, '.', false)};

                    dataSumItemPositive[keyStart] = {key: keyStart, label: this.$t('pref.main.sumPositive')};
                    dataSumItemPositive['total'] = {key: 'total', label:  '€ ' + view.$helpers.ProcessNumericLabel(sumVacationPaymentPositive, 2, '.', false)};

                    dataSumItemNegative[keyStart] = {key: keyStart, label: this.$t('pref.main.sumNegative')};
                    dataSumItemNegative['total'] = {key: 'total', label:  '€ ' + view.$helpers.ProcessNumericLabel(sumVacationPaymentNegative, 2, '.', false)};

                    state.headerMap[keyStart].stylesEntrySum = sumStyle;
                    state.headerMap['total'].stylesEntrySum = sumStyleTotal;
                    dataSum.push(dataSumItemPositive);
                    dataSum.push(dataSumItemNegative);
                    dataSum.push(dataSumItem);
                    state.dataSum = dataSum;

                    
                }
                

                return state;
            },
        },
        watch: {
            storeId(newVal, oldVal) {
                this.Refresh();
            },
            date(newVal, oldVal) {
                this.Refresh();
            },
        },
        // methods that implement data logic.
        methods: {
            
            OpenMenuDetails($event, state){
                let view = this;

                this.$helpers.OpenPopup({
                    type: 'burgermenu',
                    componentState: state,
                    listStyle: true,
                    noScroll: true,
                    pointerDirection: 0,
                    elRelative: $event.currentTarget,
                    pointerOffset: -15,
                });
            },
            calculateVacationPaymentForEmployee(data){
                let current = this.postCarriedOverDays(data);
                if(!this.displayInHours && !this.displayExact){
                    current = Math.ceil(current);
                }
                let contract = this.employeeIdContractMap[data.id];
                
                let vacationPayment = 0;
                if(contract != undefined){
                    
                    let payment = (contract.payment + contract.extraPayment) / 100;
                    
                    if(isNaN(payment)) payment = 0;
                    if(contract.paymentType == 2){
                        
                        let daysRegular = contract.weekWorkDaysRegular ? contract.weekWorkDaysRegular : 5;
                        let weekWorkTime = contract.weekTimeRegular ? contract.weekTimeRegular : 40*60;
                        let dayWorkTime = Math.round(weekWorkTime/daysRegular);
                        let monthWorkTime = Math.round(weekWorkTime * 4.325);
                        
                        if(contract.wageType == 4) {// Monatslohn
                            payment = (contract.payment + contract.extraPayment) / 100;
                        } else if(contract.wageType == 3) { //Wochenlohn
                            let hourlyWage = Math.round((contract.payment + contract.extraPayment) /(weekWorkTime/60));
                            payment = Math.round(weekWorkTime/60 * 4.325 * hourlyWage) / 100;
                        } else if(contract.wageType == 2) { //Tageslohn
                            let hourlyWage = Math.round((contract.payment + contract.extraPayment) /(dayWorkTime/60));
                            payment = Math.round(weekWorkTime/60 * 4.325 * hourlyWage) / 100;
                        } else if(contract.wageType == 1) { //Stundenlohn
                            let hourlyWage = (contract.payment + contract.extraPayment);
                            payment = Math.round(weekWorkTime/60 * 4.325 * hourlyWage) / 100;
                        } 
                        
                    }
                    vacationPayment = (payment + 2 * (payment/12)) / 22 * current;
                }
                
                return vacationPayment;
            },
            Refresh(){
                
                if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
                    let view = this;
                    let employeePayload = { ids: [] };
                    view.loading = true;
                    view.$store.commit("setAllowContentSwitch", {allowContentSwitch: false});
                    view.$helpers.GetStoreSettings();
                    let tEwb = 0;
                    this.loadActiveEmployees()
                    .then(map => {
                        view.employeeMap = map;
                        for(let i in view.employeeMap){
                            let employee = view.employeeMap[i];
                            if(employee.active){
                                employeePayload.ids.push(employee.id);
                            }
                        }
                        tEwb = performance.now();
                        view.loadingText = this.$t('pref.main.calculateUpdateLoading')
                        return view.RecalculatePreviousMonthWorkbalances(employeePayload.ids);
                    }).then(response => {
                        
                        let seconds = (performance.now()-tEwb) / 1000.0;
                        console.log("EWB RECALC TOOK " + seconds + " seconds.");
                        view.loadingText = this.$t('workBalance.averages.loading')
                        return view.loadVacationsForEmployees();
                    }).then(map => {
                        view.vacationMap = map;
                        return view.$helpers.GetEmployeeContractMap();
                    }).then(response => {
                        return view.$helpers.GetHolidayMap(false, false, view.date.year());
                    }).then(response => {
                        return view.$helpers.GetPreviousYearDecemberEmployeeWorkbalanceMapForEmployees(view.date.year(), employeePayload, true);
                    }).then(response =>{
                        return view.$helpers.GetSpotMap();
                    }).then(response => {
                        view.spots = response.data;
                        view.loadFilterDropdown();
                        return view.loadPreUsageDateBalances(employeePayload);
                    }).then(response => {
                        view.preUsageStartDateBalances = response.data;
                        let from = view.$helpers.getMomentFromValuesUTC(view.date.year(), 0, 1).format();
                        let to = view.$helpers.getMomentFromValuesUTC(view.date.year()+1, 0, 1).format();
            
                        return view.loadEmployeeWorkBlancesPagedCompletely(from, to, 1, []);
                    }).then(data => {
                        view.updateEmployeeWorkBalanceMapForYear(data);
                        view.BuildVacationEntryMap();
                        view.loading = false;
                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});
                        
                     }).catch(error => {
                        console.log(error);
                        view.$store.commit("setAllowContentSwitch", {allowContentSwitch: true});
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                    });
                }
            },
            RecalculatePreviousMonthWorkbalances(employeeIds) {
                let yearDate = this.$helpers.getMomentFromValuesUTC(this.date.year(), 11, 1);
                
                return this.$refs.employeeworkbalancecreation.recalculatePastInvalid(yearDate, employeeIds, null, false, true); // recalc silent to avoid the huge load of success notifications
            },
            loadEmployeeWorkBlancesPagedCompletely : function(from, to, page = 1, data = []) {
        
                let url = '/api/sec/employeeworkbalance';
                let params = {
                        storeId: this.$store.state.storeId,
                        from: from,
                        to: to,
                        page: page,
                }

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                
                    if (response.data.length < 1 ) {
                        return data;
                    } else {
                        data.push(...response.data);
                        return this.loadEmployeeWorkBlancesPagedCompletely(from, to, page+1, data);
                    } 
                
                
                })
                    
                
            },
            updateEmployeeWorkBalanceMapForYear(data){
                let map = {}
                data.forEach(entry => {
                    if(!map[entry.employeeId]){
                        map[entry.employeeId] = {};
                    }
                    let mapEntry = map[entry.employeeId]
                    let key = this.$helpers.getMomentFromStringUTC(entry.date).format("MM-YYYY");
                    mapEntry[key] = entry;
                })
                this.employeeWorkBalanceMapForYear = map;
            },
            loadPreUsageDateBalances(employeePayload){
                if(this.usageStartDateInCurrentYear){
                    let view = this;
                    let url = '/api/sec/employeeworkbalance/any/employee';
                    let from = this.usageStartDate.clone().subtract(1, 'months').startOf('month');
                    
                    let params = {
                        storeId: this.$store.state.storeId,
                        from: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 1).format(),
                        to: this.$helpers.getMomentFromValuesUTC(from.year(), from.month(), 2).format(),
                    };
                    return this.axios({
                        method: 'post',
                        params: params,
                        headers: {
                            'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url,
                        data: employeePayload
                    });
                }else{
                    return new Promise((resolve, reject) => {
                        resolve({data:[]});
                    });
                }
            },
            loadFilterDropdown(){
                var view = this;
                this.filterDropdownOptions = [];
                Object.values(view.spotMap).forEach(function(spot){
                        var option = {label: spot.name, show:true, toggled: true, color: spot.color, spot: spot};
                        view.filterDropdownOptions.push(option);
                });
                this.filterDropdownOptions.push({label: this.$t('pref.main.noMainPosition'), toggled: true, all: false, show: true, color: "#000000", spot: {id: null}})
                this.filterDropdownOptions.push({label: this.$t('pref.main.showAll'), toggled: true, all: true, color: "#000000"})
            },
            OpenFilterDropdown($event){
                var view = this;
                var target = $event.currentTarget;


                this.$helpers.OpenPopup({
                    elRelative: target,
                    type: 'list',
                    componentState: {
                        entries: view.filterDropdownOptions,
                    },
                    remainAfterSelect: true,
                    pointerDirection: 0,
                    iconsLeft: true,
                    selectCallback: function($event, item, dropdown){
                        item.toggled = !item.toggled;
                        if(item.all) {
                            view.filterDropdownOptions.forEach(option => {
                                option.toggled = item.toggled;
                                option.show = item.toggled;
                            })
                        }else{
                            view.filterDropdownOptions.forEach(option => {
                                if(!option.all && option.spot.id == item.spot.id){
                                    option.show = item.toggled;
                                }
                            });
                        }
                    },
                });
            },
            loadSpots : function() {

                let url = '/api/sec/spot';

                let params = {
                    storeId: this.$store.state.storeId,
                };

                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                })


            },
            postCarriedOverDays(employee){
                let current = 0;
                let view = this;
                let entry = this.vacationEntryMap[employee.id+" "+11];
                if(entry && entry.visible){
                    current = entry.aliquoteRemaining;
                }
                return current;
                
            },
            OpenMonthlyPopup(employee, month){
                let view = this;
                let entry = this.vacationEntryMap[employee.id+" "+month];
                let carriedOver = 0;
                let entitled = entry.entitled;
                for(let y = 0; y < month; y++) {
                    let tEntry = this.vacationEntryMap[employee.id+" "+y]
                    entitled = tEntry.entitled;
                    carriedOver += entitled - tEntry.currentMonth;
                }
                if(this.employeeIdCarriedOverMap[employee.id]){
                    carriedOver+=this.employeeIdCarriedOverMap[employee.id]/(24*60)
                }
                entitled = entry.entitled;
                this.$helpers.OpenPopup({
                    type: 'vacationmonthpopup',
                    componentState: {
                        employee: employee,
                        date: view.date.clone().month(month).startOf('month'),
                        entitled: entitled,
                        carriedOver: carriedOver,
                        leaveAvailable: carriedOver + entitled - entry.currentMonth,
                        currentMonth: -entry.currentMonth,
                        displayInHours: entry.displayInHours,
                        workDayHours: entry.workDayHours,
                        timeFrames: Object.values(view.vacationMapMomentMap).filter(vacation => vacation.employeeId === employee.id).map(v => view.GetTimeBarObjectFromVacationMoment(v)),
                        NextDate: (component) => {
                            view.OpenMonthlyPopup(employee, component.date.clone().add(1, 'month').month());
                        },
                        PrevDate: (component) => {
                            view.OpenMonthlyPopup(employee, component.date.clone().add(-1, 'month').month());
                        },
                    },
                    centered: true,
                    expanded: true,
                });
            },
            GetTimeBarObjectFromVacationMoment(vacation){
              let entry = {};
              for(let x in vacation){
                  entry[x] = vacation[x];
              }
                entry.startLabel = ''//vacation.toDate.dayOfYear() - vacation.fromDate.dayOfYear(); dont display nr of days because vacations on weekends dont count and causes for confusion
                entry.endLabel = '';
              return entry;
            },
            BuildVacationEntryMap(){
                let employees = this.filteredEmployeeMap ? Object.values(this.filteredEmployeeMap) : [];
                let map = {}
                
                employees.forEach(e => {
                    let prevYearLeftOver = 0;
                    let sumVacationUsed = 0;
                    let sumVacationBalance = 0;
                    for(let month = 0; month < 12; month++){
                        let key = e.id+" "+month;
                        let entry = {aliquoteRemaining: 0, 
                                     entitled: 0, 
                                     currentMonth: this.employeeMonthlyVacationDaysMap[e.id][month], 
                                     visible: false, 
                                     aliquoteRemainingOnly: false, 
                                     displayInHours: this.displayInHours,
                                     displaySummed: this.displaySummed, 
                                     displayExact: this.displayExact,
                                     workDayHours: 8,
                                     sumVacationUsed: 0,
                                     sumVacationBalance: 0,
                                     sumVacationRemaining: 0}
                        
                        let monthFrom = this.$helpers.getMomentFromValuesTZ(this.date.year(), month, 1);
                        let mainContract = this.getContractForEmployee(e.id, this.date.year(), month);
                        let contractNextMonth = null;
                                    
                        if(month == 11){
                            contractNextMonth = this.getContractForEmployee(e.id, this.date.year()+1,0);
                        } else {
                            contractNextMonth = this.getContractForEmployee(e.id, this.date.year(), month+1);
                        }
                        let firstContract = this.getFirstContractForEmployee(e.id);
                        let fcCondition = false;
                        if(firstContract){
                            let fcFrom = this.$helpers.getMomentFromStringTZ(firstContract.from).add(-1, 'months')
                            if(fcFrom.month() == monthFrom.month() && fcFrom.year() == monthFrom.year() && monthFrom.month() != 11){
                                fcCondition = true;
                                mainContract = firstContract;
                            }
                        }

                        if(mainContract && (month >= this.usageStartDateMonth - 1 || !this.usageStartDateInCurrentYear)){
                            entry.visible = true;
                        }
                        
                        
                        

                        if(this.usageStartDateInCurrentYear && month < this.usageStartDateMonth - 1){
                            entry.entitled = 0;
                        } else {
                            
                            let wbKey = monthFrom.format("MM-YYYY");
                            let prevMonth = monthFrom.clone().add(-1, 'months');
                            if(this.employeeWorkBalanceMapForYear[e.id] && this.employeeWorkBalanceMapForYear[e.id][wbKey] && this.employeeWorkBalanceMapForYear[e.id][wbKey].valid){
                                //valid employeeworkbalance found => determine aliquote entitlement from vacationTimeBalance
                                let ewb = this.employeeWorkBalanceMapForYear[e.id][wbKey]
                                let baseEntitlement = ewb.vacationTimeBalance+ewb.vacationTime;

                                if(((mainContract != null && contractNextMonth != null) || fcCondition) && this.date.year() < 2021){
                                    //employee has contract in current and next month or it is the month before the first contract and not december (firstcontract ewbs in december don't have aliquote balance since january adds yearly balance)
                                    //=> contract doesnt end, therefore calculate aliquote
                                    let cVacationEntitlement = mainContract.vacationTime/ (60 * 12 * 24);
                                    let subtraction = ((12 - (month+1) ) * cVacationEntitlement);
                                    
                                    let leave = (baseEntitlement / (60 * 24)) - subtraction;
                                    entry.aliquoteRemaining = leave;
                                    if(fcCondition){
                                        entry.aliquoteRemaining = 0;
                                    }
                                } else {
                                    
                                    //contract ends or we are in 2021 => use entitlement as is, since it is already aliquote
                                    entry.aliquoteRemaining = baseEntitlement / (60 * 24);
                                }
                                entry.currentMonth = ewb.vacationTime /(60*24)
                            } else {
                                //no valid workbalance found => take previous entry and add aliquote entitlement from contract
                                let prevEntitlement = 0;
                                if(month == 0){
                                    //take from prev year
                                    prevEntitlement = (this.employeeIdCarriedOverMap[e.id] ? this.employeeIdCarriedOverMap[e.id] : 0)/(24*60);
                                 } else {
                                    let prevKey = e.id+" "+(month-1);
                                    prevEntitlement = map[prevKey].aliquoteRemaining;
                                }
                                let cVacationEntitlement = this.CalculateVacationEntitledFromContract(e, month, this.storeSettings);
                                
                                entry.aliquoteRemaining = prevEntitlement+cVacationEntitlement;
                                
                                
                            }
                            
                        }
                        let prevLeave = 0;
                        if(month == 0){
                            //take from prev year
                            prevLeave = (this.employeeIdCarriedOverMap[e.id] ? this.employeeIdCarriedOverMap[e.id] : 0)/(24*60);
                            prevYearLeftOver = prevLeave;
                        } else {
                            let prevKey = e.id+" "+(month-1);
                            prevLeave = map[prevKey].aliquoteRemaining;
                        }
                        //order matters here
                        entry.entitled = entry.aliquoteRemaining - prevLeave;
                        entry.aliquoteRemaining = entry.aliquoteRemaining - entry.currentMonth;
                        if(this.usageStartDateInCurrentYear && month == this.usageStartDate.month() - 1){
                            entry.aliquoteRemainingOnly = true;
                        }
                        if(this.displayInHours && mainContract){
                            entry.workDayHours = mainContract.weekTimeRegular/(mainContract.weekWorkDaysRegular*60);
                        } 
                        //sum up for summed up view
                        sumVacationBalance += entry.entitled;
                        sumVacationUsed += entry.currentMonth;
                        entry.sumVacationUsed = sumVacationUsed;
                        map[key] = entry;
                            
                    }
                    //after we established the summed up aliquote vacationbalance we need to put it in each entry for display
                    sumVacationBalance += prevYearLeftOver;
                    for(let month = 0; month < 12; month++){
                        let key = e.id+" "+month;
                        if(map[key]){
                            map[key].sumVacationBalance = sumVacationBalance;
                            map[key].sumVacationRemaining = map[key].sumVacationBalance - map[key].sumVacationUsed;
                        }
                        
                    }
                    

                });
                this.vacationEntryMap = map;
            },
            GetVacationEntryStateForMonth(e, month){
                let key = e.id+" "+month;
                return this.vacationEntryMap[key];
            },
            getFirstContractForEmployee(employeeId){
                let fcontract = null;
                if(this.employeeIdContractMultiMap[employeeId]){
                    let contracts = this.employeeIdContractMultiMap[employeeId];
                    let minFrom = null;
                    contracts.forEach(contract => {
                        let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from);
                        if(minFrom == null || contractFrom < minFrom){
                            minFrom = contractFrom;
                            fcontract = contract;
                        } 
                    });
                }
                return fcontract;
            },
            getContractForEmployee(employeeId, year, month){
                let mainContract = null
                let monthFromTZ = this.$helpers.getMomentFromValuesTZ(year, month, 1);
                
                
                if(this.employeeIdContractMultiMap[employeeId]){
                    let contracts = this.employeeIdContractMultiMap[employeeId];
                    contracts.forEach(contract => {
                        
                        let contractFrom = this.$helpers.getMomentFromStringTZ(contract.from);
                        
                        let contractTo = contract.to == null ? null : this.$helpers.getMomentFromStringTZ(contract.to);
                        if(contractFrom <= monthFromTZ && (contractTo == null || contractTo > monthFromTZ) || (contractFrom.month() == monthFromTZ.month() && contractFrom.year() == monthFromTZ.year())){
                            mainContract = contract;
                        }
                       
                    });
                }
                return mainContract;
            },
            CalculateVacationEntitledFromContract(employee, month, storeSettings){
                let view = this;
                let mode = this.date.year() < 2021 ? 0 : this.storeSettings.vacationFactoring;
                let exitFactoringMode = storeSettings.exitFactoring;

                let checkDate = this.$helpers.getMomentFromValuesUTC(this.date.year(), month, 1);
                let checkDateEnd = checkDate.clone().endOf('month').add(1, 'days').startOf('day');
                
                let contracts = this.employeeIdContractMultiMap[employee.id];
                let vacationEntitled = 0;
                let entitlement = 0
                let contractCount = 0;
                let workDays = 0;
                contracts.forEach((c) => {
                    let cStart = view.$helpers.getMomentFromStringTZ(c.from);
                    let cEnd = c.to != undefined? view.$helpers.getMomentFromStringTZ(c.to) : null;
                    let entitlementForMonth = 0;
                    if(storeSettings.aliquoteVac){
                        entitlementForMonth = view.$helpers.CalculateVacationEntitlement(cStart, cEnd, checkDate, checkDateEnd, c.vacationTime, mode, exitFactoringMode, c.vacationEntitlementBase);
                    } else {
                        entitlementForMonth = view.$helpers.CalculateVacationEntitlement(checkDate, checkDateEnd, checkDate, checkDateEnd, c.vacationTime, mode, exitFactoringMode, c.vacationEntitlementBase);

                    }
                    if(entitlementForMonth > 0){
                        contractCount++;
                        entitlement += entitlementForMonth;
                    }
                    
                    let f = cStart < checkDate ? checkDate : cStart;
                    let t =  cEnd > checkDateEnd ||  cEnd == null ? checkDateEnd :  cEnd;
                    workDays += t.diff(f, 'days');
                    

                    
                });
                if(!storeSettings.aliquoteVac){
                    entitlement = entitlement / ( contractCount > 0 ?  contractCount : 1);
                }
                if(workDays >= storeSettings.minVacEmploymentDays){
                    vacationEntitled += entitlement;
                }
                return vacationEntitled;
            },
            
            GetMonthsStartingWithZero(employee){
                if(this.employeeZeroMonthsMap[employee.id] == undefined){
                    let view = this;
                    let m = [];
                    let frames = [];
                    let id = 1;
                    let contracts = this.employeeIdContractMultiMap[employee.id];
                    contracts.forEach((c) => {
                        let cStart = view.$helpers.getMomentFromStringTZ(c.from);
                        let cEnd = c.to != undefined? view.$helpers.getMomentFromStringTZ(c.to) : null;
                        if(cStart.year() == this.date.year() || (cEnd != null && cEnd.year() == this.date.year())){
                            let month = cStart.month();
                            let endMonth = (cEnd != null && cEnd.year() == this.date.year())? cEnd.month() : -1;
                            if(!this.usageStartDateInCurrentYear || month > this.usageStartDate.month() || (endMonth != -1 && endMonth > this.usageStartDate.month())){
                                let curFrame = {
                                    'id': id,
                                    'from': cStart,
                                    'to': cEnd
                                };
                                frames.push(curFrame);
                                id++;
                            }
                        }
                    });
                    frames.forEach((f)=>{
                        f['hasPreceding'] = false;
                        frames.forEach((f2) => {
                            if(f.id != f2.id){
                                if(f2.to != null){
                                    if(f.from.year() == f2.to.year() && f.from.month() == f2.to.month()){
                                        // TODO: this has to be more precise: start and end of f and f2 in same month --> consider f2 as preceding contracts for now even if days in between
                                        f['hasPreceding'] = true;
                                    }else{
                                        // start and end of f and f2 not in same month, if diff is <= 24h we consider f2 as preceding
                                        let diffTime = Math.abs(f.from - f2.to);
                                        let diffHours = Math.ceil(diffTime / (1000 * 60 * 60));
                                        if(diffHours <= 24){
                                            f['hasPreceding'] = true;
                                        }
                                    }
                                }
                            }
                        });
                    });
                    frames.forEach((f) => {
                        if(!f.hasPreceding && f.from.year() == this.date.year() && !m.includes(f.from.month())) m.push(f.from.month());
                    });
                    this.employeeZeroMonthsMap[employee.id] = m;
                }
                return this.employeeZeroMonthsMap[employee.id];
                
            },
            
            GetVacationHoursCountedForTimeFrame(employee, date, dateCap, alwaysWork){
                let hoursCounted = 0;
               
                if((this.storeSettings.workDays.includes(date.isoWeekday()) && !this.holidayInDayOfYearMap[date.dayOfYear()]) || alwaysWork) {
                    hoursCounted = 24 - date.hours() - (date.minutes() / 60);
                    if((dateCap._d.getTime() - date._d.getTime()) / (60 * 60 * 1000) < hoursCounted) {
                        hoursCounted = (dateCap._d.getTime() - date._d.getTime()) / (60 * 60 * 1000);
                    }
                }
                
                return hoursCounted;
            },
            loadActiveEmployees() {
                let params = {
                    active: true,
                    activeAtFrom: this.date.format(),
                    activeAtTo: this.date.clone().add(1,'years').format(),
                }
                return this.$helpers.GetCall('/api/sec/employee', params)
                    .then((response) => {
                        let map = {};
                        response.data.forEach(employee => {
                            map[employee.id] = employee;
                        })
                        return new Promise((resolve, reject) => {
                            resolve(map);
                        })
                    }).catch((e) => {
                        return new Promise((resolve, reject) => {
                            reject(e);
                        });

                    });
            },
            loadVacationsForEmployees(){
                let url = '/api/sec/employeepreference/any/employee';
                //TODO: take care of loading yearly overlapping vacations
                let params = {
                    storeId: this.$store.state.storeId,
                    from: this.date.format(),
                    to: this.date.clone().add(1,'years').format(),
                    state: 1,
                    approved: true
                };
                let payload = {ids: []};
                Object.values(this.employeeMap).forEach(employee => payload.ids.push(employee.id));
                return this.axios({
                    method: 'post',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload,
                }).then((response) => {
                    let map = {};
                    response.data.filter(pref => pref.type == 1 || pref.type == 6).forEach(preference => {
                        map[preference.id] = preference;
                    })
                    return new Promise((resolve, reject) => {
                        resolve(map);
                    })
                }).catch((e) => {
                    return new Promise((resolve, reject) => {
                        reject(e);
                    });

                });
            },
            PreviousDate(){
                this.date = this.date.clone().add(-1, 'years');
            },
            NextDate(){
                this.date = this.date.clone().add(1, 'years');
            },
            SetDateToCurrentDay(){
                this.date = this.$helpers.getMomentTZ().startOf('year');
            },
            toggleDatePicker($event) {
                let view = this;
                this.$helpers.OpenDatepickerPopup(
                    { viewsEnabled: ['Y'], date: this.date.clone() },
                    {
                        OnDateSelect: (date) => { view.onDatePicked(date) },
                    },
                    { elRelative: $event ? $event.currentTarget : null });
            },
            onDatePicked(date){
                this.date = date.startOf('year');

            },
            
            SetFilterText(text){
                let temp = [];
                temp.push((data) => {
                    return (data.firstName + ' ' + data.lastName).toLowerCase().indexOf(text.toLowerCase()) > -1 || data.id.toLowerCase().indexOf(text.toLowerCase()) > -1;
                });
                this.tableFilters = temp;
            },
            openSelectMonthPDFPopup(){
                let view = this;
                let monthEntries = [];
                for(let i = 0; i < 12; i++){
                    let l = this.$helpers.getMomentTZStartOfDay().month(i).format('MMMM');
                    monthEntries.push({label: l, key: i, value: i});
                }
                
                let dataEntries = [];
                dataEntries.push({label: this.$t('pref.main.selectMonth'), key: 'month', hidden: false, type: 'dropdownsearch', value: null, selectMultiple: false, flexGroup: false,
                    dropdownSearchState:{
                        toggled: false,
                        displayedItems: [],
                        input: '',
                        items: monthEntries,
                        selectMultiple: false,
                        selectedItems: [],
                        selectedItem: {},
                        selectFirst: true,
                        onceSelected: function ($event, item, searchbar){

                        },
                styleLight: true,
                placeholder: this.$t('pref.main.selectMonth'),
                },
                });
                

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: '',
                        selectCallback: function (data) {
                            view.exportSelectedMonthPDF(data.month);
                        }
                    },
                    header: this.$t('global.ui.pdfExport'),
                    expanded: true,
                    width: "700px",
                    centered: true
                });
            },
            exportSelectedMonthPDF(month){
                let view = this;
                let monthName = this.$helpers.getMomentTZStartOfDay().month(month).format('MMMM');
                let monthKey = 'month'+month;
                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$t('pages.employeeData.name'), this.$t('pref.main.usedVacationN') + '\n'+monthName, this.$t('pref.main.remainingVacationEndN') + ' '+monthName, this.$t('pref.main.remainingVacationN') + '\n'+this.yearDisplay];
                let body = [];

                console.log(this.dataTableState);

                this.dataTableState.data.forEach((data) => {
                    let entry = view.GetVacationEntryStateForMonth(data, month);
                    if(entry && entry.visible){
                        let row = [];
                        console.log(entry);

                        let labelUsed = (Math.round(-entry.currentMonth * (entry.displayInHours ? entry.workDayHours : 1) * 100) / 100).toFixed(2);
                        labelUsed.replace('.', ',');

                        let labelRemaining = (Math.round((entry.displayExact ? entry.aliquoteRemaining : Math.ceil(entry.aliquoteRemaining)) * (entry.displayInHours ? entry.workDayHours : 1) * 100) / 100).toFixed(2);
                        labelRemaining.replace('.', ',');

                        let labelRemainingTotal = (Math.round((entry.displayExact ? entry.sumVacationRemaining : Math.ceil(entry.sumVacationRemaining)) * (entry.displayInHours ? entry.workDayHours : 1) * 100) / 100).toFixed(2);
                        labelRemaining.replace('.', ',');

                        row.push(data.personnelId ? data.personnelId : '');
                        row.push(data.lastName + ' ' + data.firstName);
                        row.push(labelUsed);
                        row.push(labelRemaining);
                        row.push(labelRemainingTotal);
                        body.push(row);
                    }
                });

                
                let filename = this.$t('pref.main.vacOverview') + '_' + monthName+'_'+this.yearDisplay+'.pdf';
                let repDoc = this.$helpers.tableReportDoc(
                    headers,
                    this.$t('pref.main.vacOverview') + ' ' + monthName+' '+this.yearDisplay,
                    this.storeSettings.name,
                    this.storeSettings.description,
                    this.userFullname,
                    9);
                let doc = repDoc.doc;
                let contentOffsetY = repDoc.contentOffsetY;
                doc.setFontSize(12);

                doc.setProperties({
                    title: this.$t('pref.main.vacOverview')
                });

                doc.autoTable({
                    startY: contentOffsetY,
                    head: [headers],
                    body: body,
                    headStyles: {
                        fillColor: [109,141,33],
                        fontSize: 7,
                    },
                    bodyStyles: {
                        fontSize: 7
                    },
                    columnStyles: {
                    },
                    horizontalPageBreak: headers.length > 15,
                    horizontalPageBreakRepeat: 0,
                });

                view.$helpers.previewPdf(doc, filename);
            
            },
            openExportCsvPopup(){
                let view = this;
                let description = "";

                
                let dataEntries = [];

                dataEntries.push({label: "Summenzeile hinzufügen", key: 'sumFlag', hidden: false, type: 'bool', value: false});

                view.$helpers.OpenPopup({
                    type: 'datafill',
                    componentState: {
                        entries: dataEntries,
                        description: description,
                        selectCallback: function (data) {
                            let workbalances = [];
                            view.exportCSV(data.sumFlag);
                        }
                    },
                    header: 'CSV Export',
                    expanded: true,
                    centered: true
                });
            },
            exportCSV(includeSums){
                var date = new Date();
                let ts = ( date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2( date.getDate()) + this.$helpers.pad2( date.getHours() ) + this.$helpers.pad2( date.getMinutes() ) + this.$helpers.pad2( date.getSeconds() ) );
                
                let view = this;
                let csvPre = "data:text/csv;charset=utf-8,";
                let csv = "";
                let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$t('pages.employeeData.name'), this.$t('roster.view.carryOver'),
                        this.$t('global.general.month1At') + this.$t('pref.main.claimBubble'), this.$t('global.general.month1At') + this.$t('pref.main.useBubble'), this.$t('global.general.month1At') + this.$t('pref.main.remainBubble'), this.$t('global.general.month2') + this.$t('pref.main.claimBubble'), this.$t('global.general.month2') + this.$t('pref.main.useBubble'), this.$t('global.general.month2') + this.$t('pref.main.remainBubble'),
                    this.$t('global.general.month3') + this.$t('pref.main.claimBubble'), this.$t('global.general.month3') + this.$t('pref.main.useBubble'), this.$t('global.general.month3') + this.$t('pref.main.remainBubble'), this.$t('global.general.month4') + this.$t('pref.main.claimBubble'), this.$t('global.general.month4') + this.$t('pref.main.useBubble'), this.$t('global.general.month4') + this.$t('pref.main.remainBubble'),
                    this.$t('global.general.month5') + this.$t('pref.main.claimBubble'), this.$t('global.general.month5') + this.$t('pref.main.useBubble'), this.$t('global.general.month5') + this.$t('pref.main.remainBubble'), this.$t('global.general.month6') + this.$t('pref.main.claimBubble'), this.$t('global.general.month6') + this.$t('pref.main.useBubble'), this.$t('global.general.month6') + this.$t('pref.main.remainBubble'),
                    this.$t('global.general.month7') + this.$t('pref.main.claimBubble'), this.$t('global.general.month7') + this.$t('pref.main.useBubble'), this.$t('global.general.month7') + this.$t('pref.main.remainBubble'), this.$t('global.general.month8') + this.$t('pref.main.claimBubble'), this.$t('global.general.month8') + this.$t('pref.main.useBubble'), this.$t('global.general.month8') + this.$t('pref.main.remainBubble'),
                    this.$t('global.general.month9') + this.$t('pref.main.claimBubble'), this.$t('global.general.month9') + this.$t('pref.main.useBubble'), this.$t('global.general.month9') + this.$t('pref.main.remainBubble'), this.$t('global.general.month10') + this.$t('pref.main.claimBubble'), this.$t('global.general.month10') + this.$t('pref.main.useBubble'), this.$t('global.general.month10') + this.$t('pref.main.remainBubble'),
                    this.$t('global.general.month11') + this.$t('pref.main.claimBubble'), this.$t('global.general.month11') + this.$t('pref.main.useBubble'), this.$t('global.general.month11') + this.$t('pref.main.remainBubble'), this.$t('global.general.month12') + this.$t('pref.main.claimBubble'), this.$t('global.general.month12') + this.$t('pref.main.useBubble'), this.$t('global.general.month12') + this.$t('pref.main.remainBubble'),
                    this.$t('roster.view.carryOver'), '€'];
                if(this.displaySummed){
                    let headers = [this.$t('pages.employeeCoreData.personnelNumber'), this.$t('pages.employeeData.name'), this.$t('roster.view.carryOver'),
                                   this.$t('global.general.month1At') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month1At') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month1At') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month2') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month2') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month2') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month3') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month3') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month3') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month4') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month4') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month4') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month5') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month5') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month5') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month6') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month6') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month6') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month7') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month7') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month7') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month8') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month8') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month8') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month9') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month9') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month9') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month10') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month10') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month10') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month11') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month11') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month11') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('global.general.month12') + this.$t('pref.main.claimBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month12') + this.$t('pref.main.useBubble') + this.$t('pref.main.sumBubble'), this.$t('global.general.month12') + this.$t('pref.main.remainBubble') + this.$t('pref.main.sumBubble'),
                                   this.$t('roster.view.carryOver'), '€'];
                }
                let filename = this.$t('pref.main.vacOverview') + '_' + this.date.format('YYYY')+ '_' + this.storeSettings.name + '_' + ts +  (view.displayInHours? '_VERTRAGSSTUNDEN' : '_TAGE') +  (view.displaySummed? '_SUMMIERT' : '_ALIQUOT')+ '.csv';
                
                csv += headers.join(";");
                csv += "\n";
                
                let state = {};
                if(!view.loading){
                    let dataArray = this.filteredEmployeeMap ? Object.values(this.filteredEmployeeMap) : [];
                    dataArray.sort(function(ea, eb) {
                        if(view.sortByName){
                            if(ea != undefined && eb != undefined){
                                if(ea.lastName < eb.lastName) return - 1;
                                if(ea.lastName > eb.lastName) return 1;
                                if(ea.lastName == eb.lastName && ea.firstName < eb.firstName) return - 1;
                                if(ea.lastName == eb.lastName && ea.firstName > eb.firstName) return 1;
                            }
                        }else{
                            if(ea != undefined && eb != undefined){
                                let eaNum = ea.personnelId;
                                let ebNum = eb.personnelId;
                                if(eaNum != undefined && eaNum != null && ebNum != undefined && eaNum != ebNum != null){
                                    eaNum = parseInt(eaNum);
                                    ebNum = parseInt(ebNum);
                                    if(eaNum < ebNum) return - 1;
                                    if(eaNum > ebNum) return 1;
                                }else if(eaNum == null || eaNum == undefined){
                                    return 1;
                                }else{
                                    return -1;
                                }
                            }
                        }
                        return 0;
                    });

                    let dataSum = [];
                    let dataSumItem = {};
                    let monthSums = {};
                    for(let x = 0; x < 12; x++){
                        monthSums['month' + x] = {'emerging': 0, 'used': 0, 'remaining': 0};
                    }
                    monthSums['carriedOver'] = 0;
                    monthSums['postCarriedOver'] = 0;
                    monthSums['postCarriedOverPositive'] = 0;
                    monthSums['postCarriedOverNegative'] = 0;
                    var sumVacationPayment = 0;
                    
                    dataArray.forEach((e) => {
                        let current = view.postCarriedOverDays(e);
                        let carriedOverEntry = view.GetVacationEntryStateForMonth(e, 11);
                        let carriedOver = 0;
                        if(view.employeeIdCarriedOverMap[e.id] != undefined){
                            carriedOver += view.employeeIdCarriedOverMap[e.id] / 60 / 24;
                        }
                        
                        if(carriedOverEntry.displayInHours){
                            carriedOver = carriedOver * carriedOverEntry.workDayHours;
                            current = current * carriedOverEntry.workDayHours;
                        }

                        let cur = [e.personnelId, e.lastName + ' ' + e.firstName, carriedOver.toFixed(2)];
                        let vPayment = view.calculateVacationPaymentForEmployee(e);

                        sumVacationPayment += vPayment;
                        for(let x = 0; x < 12; x++){
                            let mkey = 'month' + x;
                            let state = view.GetVacationEntryStateForMonth(e, x);
                            
                            cur.push(((view.displaySummed ? state.sumVacationBalance : state.entitled) * (state.displayInHours ? state.workDayHours : 1)).toFixed(2));
                            cur.push(((view.displaySummed ? state.sumVacationUsed : state.currentMonth) * (state.displayInHours ? state.workDayHours : 1)).toFixed(2));
                            cur.push(((view.displaySummed ? state.sumVacationRemaining : state.aliquoteRemaining) * (state.displayInHours ? state.workDayHours : 1)).toFixed(2));
                            monthSums[mkey].emerging += Math.round((view.displaySummed ? state.sumVacationBalance : state.entitled) * (state.displayInHours ? state.workDayHours : 1)*100)/100;
                            monthSums[mkey].used += Math.round((view.displaySummed ? state.sumVacationUsed : state.currentMonth) * (state.displayInHours ? state.workDayHours : 1)*100)/100;
                            monthSums[mkey].remaining += Math.round((view.displaySummed ? state.sumVacationRemaining : state.aliquoteRemaining) * (state.displayInHours ? state.workDayHours : 1)*100)/100;
                        }

                        cur.push(current.toFixed(2));
                        cur.push(vPayment.toFixed(2));
                        
                        monthSums['carriedOver'] += Math.round(carriedOver*100)/100;
                        monthSums['postCarriedOver'] += Math.round(current*100)/100;
                        if(current > 0){
                           monthSums['postCarriedOverPositive'] += current; 
                        } else {
                            monthSums['postCarriedOverNegative'] += current;
                        }
                        csv += cur.join(";");
                        csv += "\n";
                    });
                    if(includeSums){
                        let sumRow = ['Summe', '', monthSums['carriedOver'].toFixed(2)];
                        for(let x = 0; x < 12; x++){
                            let mkey = 'month' + x;
                            sumRow.push(monthSums[mkey].emerging.toFixed(2));
                            sumRow.push(monthSums[mkey].used.toFixed(2));
                            sumRow.push(monthSums[mkey].remaining.toFixed(2));
                        }
                        sumRow.push(monthSums['postCarriedOver'].toFixed(2));
                        sumRow.push(sumVacationPayment.toFixed(2));
                        csv += sumRow.join(";");
                        csv += "\n";
                    }
                    

                    let s = csv.split(".");
                    csv = s.join(",");
                    
                    let encodedUri = encodeURI(csvPre) + "\uFEFF" +  encodeURIComponent(csv);
                    var link = document.createElement("a");
                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename);
                    document.body.appendChild(link); // Required for FF

                    link.click();   
                }
            }
        }

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .tablecontainer{
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 30px;
    }
 
    .has-tab-menu > .has-header > .scrollbar-container{
        height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
        top: var(--header-height);
    }
    
    .holiday-overview{
       
    }
    .holiday-overview .text-filter{
        top: 75px;
    }

    @media (max-width: 1650px) {
        .holiday-overview .monthly-holiday-entry .entitled, .holiday-overview .monthly-holiday-entry .added-leave, .holiday-overview .monthly-holiday-entry .current-month {
            font-size: 12px;
        }
    }
    @media (max-width: 1550px) {
        .holiday-overview .monthly-holiday-entry{
            position: absolute;
            height: 100%;
            width: calc(100% - 10px);
            left: 5px;
            top: 0;
        }
        .holiday-overview .monthly-holiday-entry .entitled, .holiday-overview .monthly-holiday-entry .added-leave, .holiday-overview .monthly-holiday-entry .current-month {
            font-size: 12px;
            padding: 1px 0;
        }
        .holiday-overview .data-table .header .entry.label-small > .label{
            font-size: 14px;
        }
    }
    @media (max-width: 1400px) {
        .holiday-overview .monthly-holiday-entry{
            width: calc(100% - 4px);
            left: 2px;
            top: 0;
        }
        .holiday-overview .data-table .header .entry.label-small > .label{
            font-size: 13px;
        }
        .holiday-overview .monthly-holiday-entry .entitled, .holiday-overview .monthly-holiday-entry .added-leave, .holiday-overview .monthly-holiday-entry .current-month {
            font-size: 11px;
            padding: 0;
        }
    }
    @media (max-width: 1300px) {
        .holiday-overview .data-table .header .entry.label-small > .label{
            font-size: 12px;
        }
    }
</style>
